import { ArrowBack, TocOutlined } from "@mui/icons-material";
import {
  Chip,
  Divider,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import moment from "moment";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import GJChip from "../../../../components/GJChip";
import { formatMonthToString } from "../_utils/format-month";
import DocumentGeneralJournalAccrualReversalActions from "../DocumentGeneralJournalAccrualReversalActions";
import TablePreloader from "../../adjusting-entries/TablePreloader";
import NoRecordsFound from "../../../../components/NoRecordsFound";

const AccrualMonth = () => {
  const { year, month } = useParams();
  const { searchParams } = useQueryParams();

  const navigate = useNavigate();
  const { data, isError, isFetching, handlePrint, handleViewEntries, handleManageEntries } =
    useOutletContext();

  const onNavigateBack = () => {
    const newParams = new URLSearchParams();
    newParams.set("is_reversed", "0");
    newParams.set("status", "pending");
    navigate({
      pathname: `/general-journal/accrual-and-reversal/${year}`,
      search: newParams.toString(),
    });
  };

  const status = searchParams.get("status"); // "pending"
  const is_reversed = searchParams.get("is_reversed");

  return (
    <>
      <Stack>
        <Divider sx={{ marginTop: 2 }} />
        <Stack direction="row" gap={1} height="6vh" alignItems="center" padding={2}>
          <Tooltip title="Back">
            <IconButton onClick={onNavigateBack} color="inherit">
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Stack direction="row" gap={1}>
            <TocOutlined sx={{ opacity: 0.9 }} />
            <Typography fontWeight={500} fontSize={13} sx={{ opacity: 0.9 }}>
              General Journal Month: <GJChip title={formatMonthToString(month)} />
            </Typography>
          </Stack>
        </Stack>
        <Divider />
      </Stack>
      <TableContainer className="FstoTableContainer-root">
        <Table className="FstoTable-root" size="small">
          <TableHead className="FstoTableHead-root">
            <TableRow className="FstoTableRow-root">
              <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                JOURNAL NAME
              </TableCell>
              <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                DESCRIPTION
              </TableCell>
              <TableCell className="FstoTableCell-root FstoTableCell-head FstoTabCell-color">
                DIVISION
              </TableCell>
              {Boolean(Number(is_reversed)) && !isFetching && (
                <TableCell
                  className="FstoTableCell-root FstoTableCell-head FstoTabCell-color"
                  sx={{ width: "10%" }}
                >
                  <TableSortLabel active={false}>DATE REVERSED</TableSortLabel>
                </TableCell>
              )}

              <TableCell
                className="FstoTableCell-root FstoTableCell-head FstoTabCell-color"
                sx={{ width: "10%" }}
              >
                <TableSortLabel active={false}>STATUS</TableSortLabel>
              </TableCell>

              <TableCell
                className="FstoTableCell-root FstoTableCell-head FstoTabCell-color"
                align="right"
              >
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody className="FstoTableBody-root">
            {!isFetching &&
              data?.data?.map((item, index) => (
                <TableRow className="FstoTableRow-root" key={index} hover>
                  <TableCell className="FstoTableCell-root FstoTableCell-body">
                    <Typography className="FstoTypography-general_journal">
                      {item.journal_name}
                    </Typography>
                  </TableCell>
                  <TableCell className="FstoTableCell-root FstoTableCell-body">
                    <Typography className="FstoTypography-general_journal">
                      {item.journal_description}
                    </Typography>
                  </TableCell>
                  <TableCell className="FstoTableCell-root FstoTableCell-body">
                    <Typography className="FstoTypography-general_journal">
                      {item?.division?.name}
                    </Typography>
                  </TableCell>
                  {Boolean(Number(is_reversed)) && !isFetching && (
                    <TableCell className="FstoTableCell-root FstoTableCell-body">
                      <Typography className="FstoTypography-general_journal">
                        {moment(item?.reversed_at).format("MMM. DD, YYYY")}
                      </Typography>
                    </TableCell>
                  )}
                  <TableCell className="FstoTableCell-root FstoTableCell-body">
                    <Chip
                      label={status}
                      size="small"
                      color="warning"
                      sx={{ textTransform: "capitalize" }}
                    />
                  </TableCell>
                  <TableCell className="FstoTableCell-root FstoTableCell-body" align="right">
                    <DocumentGeneralJournalAccrualReversalActions
                      is_reverse={is_reversed}
                      data={item}
                      onView={handleViewEntries}
                      onManage={handleManageEntries}
                      onPrint={handlePrint}
                    />
                  </TableCell>
                </TableRow>
              ))}

            {Boolean(isFetching) && <TablePreloader row={3} />}
          </TableBody>
        </Table>

        {(isError || Boolean(!data?.data?.length)) && Boolean(!isFetching) && <NoRecordsFound />}
      </TableContainer>
    </>
  );
};

export default AccrualMonth;
